__turbopack_context__.v({
  "fullscreen": "Loader-module-scss-module__u6YIRG__fullscreen",
  "inline": "Loader-module-scss-module__u6YIRG__inline",
  "loader": "Loader-module-scss-module__u6YIRG__loader",
  "small": "Loader-module-scss-module__u6YIRG__small",
  "spin": "Loader-module-scss-module__u6YIRG__spin",
  "spinner": "Loader-module-scss-module__u6YIRG__spinner",
});
